import { render, staticRenderFns } from "./CartNavigation.vue?vue&type=template&id=27af60c6&"
import script from "./CartNavigation.vue?vue&type=script&lang=js&"
export * from "./CartNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports